import {createContext} from "react";

export const SearchContext = createContext(null)

export const Provider = ({childern}) =>{

}